





















































import { Component, Vue } from 'vue-property-decorator';
import ExpandablePanel from '@/components/ExpandablePanel.vue';
import AddNodeButton from '@/components/buttons/AddNodeButton.vue';
import ButtonGrid from '@/components/buttons/ButtonGrid.vue';
import { OverviewCategories, OverviewNodes } from '@/nodes/overview/Types';
import SearchBar from '@/SearchBar.vue';
import { Getter } from 'vuex-class';
import { EditorModel } from '@/store/editors/types';
import EditorManager from '@/EditorManager';
import Scrollable from '@/components/wrappers/Scrollable.vue';
import Padded from '@/components/wrappers/Padded.vue';

@Component({
  components: {
    Padded,
    Scrollable,
    SearchBar,
    ExpandablePanel,
    AddNodeButton,
    ButtonGrid,
  },
})
export default class ComponentsTab extends Vue {
  private readonly overviewNodes = OverviewNodes;
  private readonly overviewCategories = OverviewCategories;
  private nodeList = EditorManager.getInstance().overviewCanvas.nodeList;
  private searchString = '';
  @Getter('modelEditors') modelEditors!: EditorModel[];
  @Getter('dataEditors') dataEditors!: EditorModel[];

  private search(search: string) {
    this.searchString = search;
  }

  private get renderedModelEditors() {
    return this.modelEditors
      .filter((editor) => this.shouldRender(editor.name));
  }

  private get renderedDataEditors() {
    return this.dataEditors
      .filter((editor) => this.shouldRender(editor.name));
  }

  private get renderedNodes() {
    return this.nodeList.map((section) => ({
      category: section.category,
      nodes: section.nodes.filter((node) => this.shouldRender(node.name)),
    }));
  }

  private shouldRender(button: string) {
    return button.toLowerCase().includes(this.searchString.toLowerCase());
  }
}
